document.addEventListener('click', function (event) {
  const thumb = event.target.closest('[data-product-thumb]');
  if (thumb) {
    const gallery = thumb.closest('.os-product-page__gallery');
    const main = gallery && gallery.querySelector('[data-product-main]');
    if (main && thumb.dataset.fullSrc) {
      main.src = thumb.dataset.fullSrc;
      gallery.querySelectorAll('[data-product-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
    }
  }
  const minus = event.target.closest('[data-quantity-minus]');
  const plus = event.target.closest('[data-quantity-plus]');
  if (minus || plus) {
    const wrap = event.target.closest('.os-quantity');
    const input = wrap && wrap.querySelector('input[type="number"]');
    if (input) {
      const current = parseInt(input.value || '1', 10);
      input.value = String(Math.max(1, current + (plus ? 1 : -1)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
});

document.addEventListener('change', function (event) {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const price = document.querySelector('[data-product-price]');
  if (price && option && option.dataset.price) {
    const amount = Number(option.dataset.price) / 100;
    const currency = document.documentElement.lang && document.documentElement.lang.toLowerCase().startsWith('en') ? 'USD' : 'USD';
    try { price.textContent = new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount); }
    catch (e) { price.textContent = amount.toFixed(2); }
  }
});
